let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6GQPH")).then(() => parcelRequire('czuGd'));